module.exports = __webpack_public_path__ + "static/media/NexterWebsite_17.c6fb1365.webp";